import React, { useCallback } from 'react';
import { styles } from './styles';
import { Checkbox } from "../../../controls";
export var GridHeaderCheckboxCell = React.memo(function GridTextCell(props) {
    var onClick = useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        props.onClick();
    }, [props.onClick]);
    return (React.createElement("div", { className: styles.root },
        React.createElement(Checkbox, { onClick: onClick, checked: !!props.checked, indeterminate: props.checked === null })));
});
//# sourceMappingURL=GridHeaderCheckboxCell.js.map